export abstract class BaseModel{

    public id:number;
    public status:any;
    public received_date:any;
    public in_process_date:any;
    public sent_date:any;

}
